export default __webpack_public_path__ + "static/media/copy.a5bc6cd7.svg";